module.exports = __webpack_public_path__ + "07_bob_gray.0a4e30c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_bob_gray.png
// module id = +4P8
// module chunks = 0